<template>
    <div class="pop-get">
        <div class="pop-bg"></div>
        <div class="pop-get-content">
            <div class="title g-flex-center-center">
                <div class="pop-title-icon"></div>
                <p class="title-text qm-special-font">{{ store.magicWeapon.title }}</p>
                <div class="pop-title-icon title-right"></div>
                <div class="title-bg pop-title-bg"></div>
            </div>
            <p class="award-desc">{{ store.magicWeapon.second_title }}</p>
            <div class="award">
                <div class="award-img">
                    <div class="award-img-bg pop-award-bg"></div>
                    <transition name="fade">
                        <img v-if="!isStartAnimate" class="award-img-item" :src="store.magicWeapon.icon" alt="" />
                    </transition>
                    <canvas class="award-img-svga" ref="refSvga"></canvas>
                </div>
                <div class="g-flex-center-center" v-if="store.magicWeapon.status === '2'">
                    <p class="award-used">已使用</p>
                </div>
                <p class="award-name" v-if="store.magicWeapon.status === '0'">碎片 {{ store.magicWeapon.user_fragment_num }}/{{ store.magicWeapon.need_fragment_num }}</p>
                <div class="award-btn button-1 g-flex-center-center" @click="onClick">
                    <p class="award-btn-text">{{ btnStatus.text }}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, computed, getCurrentInstance, onMounted } from 'vue';
import { useStore } from '@/store';
import { useStoreCommon } from '@common/store/common';
import { apiUseMagicWeapon } from '@/http/api';
import { Player } from 'svga';
const instance = getCurrentInstance();
const emits = defineEmits(['refresh']);
const store = useStore();
const storeCommon = useStoreCommon();
// status 0.待合成，1.已合成待使用，2.已使用
const btnStatus = computed(() => {
    const { user_fragment_num, need_fragment_num, status, } = store.magicWeapon;
    if (status === '1') {
        return {
            text: '使用',
            type: 'use',
        };
    }
    if (status === '2') {
        return {
            text: '我知道了',
            type: 'close',
        };
    }
    if (user_fragment_num === need_fragment_num) {
        return {
            text: '合成',
            type: 'compose',
        };
    }
    if (store.isAnswered) {
        return {
            text: '今日已答题',
            type: 'answered',
        };
    }
    return {
        text: '前往获得',
        type: 'get',
    };
});

const onUse = async() => {
    const res = await apiUseMagicWeapon({ category: 2, });
    store.setMagicWeapon({
        ...store.magicWeapon,
        status: '2',
    });
    store.setPopStatus('view', false);
    instance!.proxy.$toast('使用成功');
    emits('refresh');
};
let player: Player;
const isStartAnimate = ref(false);
const onCompose = async() => {
    const svgaFile = store.svgaFiles['magic-weapon'];
    if (!svgaFile || !player) {
        instance!.proxy.$toast('资源加载中，请稍后再试');
        return;
    }
    player.start();
    isStartAnimate.value = true;
    const res = await apiUseMagicWeapon({ category: 1, });
    const { magic_weapon, } = res;
    // 播放合成动画，使用svga的首帧和最后一帧
    store.setMagicWeapon({
        ...store.magicWeapon,
        ...magic_weapon,
    });
};
const onGet = () => {
    const targetDom = document.querySelector('.answer-module') as HTMLDivElement;
    if (!targetDom) {
        return;
    }
    store.setPopStatus('view', false);
    try {
        window.scrollTo({
            top: targetDom.offsetTop,
            behavior: 'smooth',
        });
    } catch (er) {
        window.scrollTo(0, targetDom.offsetTop - storeCommon.headerHeight);
    }
};
const onClick = () => {
    switch (btnStatus.value.type) {
        case 'use':
            onUse();
            break;
        case 'compose':
            onCompose();
            break;
        case 'get':
            onGet();
            break;
        case 'answered':
        case 'close':
            store.setPopStatus('view', false);
            break;
    }
};

const refSvga = ref();
const initSvga = async() => {
    const svgaFile = store.svgaFiles['magic-weapon'];
    if (!refSvga.value || !svgaFile) {
        setTimeout(() => {
            initSvga();
        }, 60);
        return;
    }
    player = new Player(refSvga.value);
    await player.mount(svgaFile);
    player.config.loop = 1;
};
onMounted(() => {
    initSvga();
});
</script>
<style lang="scss" scoped>
.pop-get {
    position: relative;
    width: 600px;
    margin: 0 auto;
    .pop-get-content {
        position: absolute;
        top: 78px;
        left: 0;
        right: 0;
        bottom: 0;
    }
}

.title {
    position: relative;
    &-text {
        position: relative;
        z-index: 2;
        font-size: 48px;
        color: #276ad1;
        line-height: 50px;
        padding: 0 16px;
    }
    &-bg {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 4px;
        margin: auto;
    }
    &-right {
        transform: rotate(180deg);
    }
}

.award {
    &-desc {
        margin-top: 10px;
        font-size: 24px;
        color: rgba(81, 116, 180, 0.8);
        line-height: 34px;
        padding: 0 50px;
    }
    &-used {
        font-size: 20px;
        color: #969696;
        line-height: 28px;
        padding: 2px 4px;
        border: 1px solid rgba(188, 189, 192, 0.52);
        border-radius: 4px;
        margin-top: 6px;
        margin-bottom: -6px;
    }
    &-img {
        width: 240px;
        height: 240px;
        margin: 26px auto 0;
        position: relative;
        &-item {
            width: 100%;
            height: 100%;
            position: relative;
            z-index: 3;
        }
        &-bg {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        &-svga {
            width: 320px;
            height: 320px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 2;
        }
    }
    &-name {
        font-size: 24px;
        color: rgba(81, 116, 180, 0.8);
        line-height: 34px;
        text-align: center;
    }
    &-btn {
        position: relative;
        z-index: 2;
        margin: 20px auto 0;

        &-text {
            font-weight: bold;
            font-size: 28px;
            color: #a9582f;
            line-height: 1.2;
        }
    }
}
</style>
